import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "1440",
  height: "120",
  viewBox: "0 0 1440 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0.103664 0L0 0V120H1440V0H1439.9C1433.31 47.2393 1113.52 85.2893 720 85.2893C326.477 85.2893 6.69193 47.2393 0.103664 0Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }